import React, { useEffect } from "react";

import estilo from "./styles/Perfil.module.css";

import foto from "../img/foto-perfil.png";
import MetaDecorator from "../utils/MetaDecorator";

function Perfil() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={estilo.perfil}>
      <MetaDecorator
        titulo={"Bryan's WebFolio"}
        subtitulo={"Bryan's WebFolio"}
        descripcion={
          "¡Bienvenido/a a mi página web! Soy Bryan Ticona Valencia, un Tecnico en Computación e Informática apasionado por la creatividad y la innovación. En este sitio web, podrás conocer más sobre mi trabajo y mi trayectoria profesional. En mi sección de portafolio, encontrarás una selección de mis proyectos más destacados, en los que he puesto en práctica mi habilidad para resolver problemas de manera creativa y efectiva. Además, en la sección de contacto, puedes ponerte en comunicación conmigo para hablar sobre posibles colaboraciones, proyectos o simplemente para conversar. Estoy siempre dispuesto/a a escuchar tus ideas y necesidades, y a colaborar contigo para llevar a cabo proyectos exitosos. Espero que disfrutes navegando por mi sitio web y que encuentres lo que estás buscando. ¡Gracias por visitarme!."
        }
        url={"https://bryanticonavalencia.site/"}
        canonical={"https://bryanticonavalencia.site/"}
      ></MetaDecorator>

      <div className={estilo.perfil_foto}>
        <div className={estilo.contenedor_foto}>
          <img src={foto} alt="foto" />
        </div>

        <div className={estilo.subtitulo}>
          <p>Desarrollador Web</p>
        </div>
      </div>

      <div className={estilo.perfil_datos}>
        <div className={estilo.titulo}>
          <h1>PORTA</h1>
          <h1>FOLIO</h1>
        </div>
        <p>TICONA VALENCIA BRYAN ROSELBET</p>

        <div className={estilo.año}>
          <p>2023</p>
        </div>
      </div>
    </div>
  );
}

export default Perfil;
